module.exports = __webpack_public_path__ + "fonts/open-sans-v18-latin-regular.de0869e3.woff";